import React, { useState, useEffect } from 'react';
import { PasswordProtection } from '../PasswordProtection';

interface ProtectedRouteProps {
    children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        // Check if user is already authenticated (stored in sessionStorage)
        const authStatus = sessionStorage.getItem('email-editor-authenticated');
        if (authStatus === 'true') {
            setIsAuthenticated(true);
        }
        setIsLoading(false);
    }, []);

    const handleAuthSuccess = () => {
        setIsAuthenticated(true);
        sessionStorage.setItem('email-editor-authenticated', 'true');
    };

    if (isLoading) {
        return <div>Loading...</div>;
    }

    if (!isAuthenticated) {
        return <PasswordProtection onSuccess={handleAuthSuccess} />;
    }

    return <>{children}</>;
};
